import { apiClient } from "@/shared/api/client";
import type { Rating } from "@/features/ratings/types";

interface RatePayload {
  stars: number;
  review_text?: string;
}

export async function rateWorker(shiftId: string, payload: RatePayload): Promise<Rating> {
  const { data } = await apiClient.post<Rating>(`/shifts/${shiftId}/rate-worker`, payload);
  return data;
}

export async function rateVenue(shiftId: string, payload: RatePayload): Promise<Rating> {
  const { data } = await apiClient.post<Rating>(`/shifts/${shiftId}/rate-venue`, payload);
  return data;
}

export async function listShiftRatings(shiftId: string): Promise<Rating[]> {
  const { data } = await apiClient.get<Rating[]>(`/shifts/${shiftId}/ratings`);
  return data;
}
